// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reworkTable .task-field-width {
  width: 400px;
}
.reworkTable .non-task-width {
  width: 110px;
}
.reworkTable .role-field-width {
  width: 120px;
}
.reworkTable .customized-min-width {
  width: 80px;
}

.rework-wrapper .dropdown-width, .changeHandling-wrapper .dropdown-width {
  width: 100%;
}
.rework-wrapper .p-column-header-content, .changeHandling-wrapper .p-column-header-content {
  padding: 5px;
}
.rework-wrapper .p-treetable .fontBoldcolor, .changeHandling-wrapper .p-treetable .fontBoldcolor {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
}
.rework-wrapper .p-treetable .p-treetable-toggler + span,
.rework-wrapper .p-treetable .p-treetable-toggler + a, .changeHandling-wrapper .p-treetable .p-treetable-toggler + span,
.changeHandling-wrapper .p-treetable .p-treetable-toggler + a {
  text-overflow: ellipsis;
  width: 88%;
  overflow: nowrap;
  overflow: hidden;
}
.rework-wrapper .p-treetable .p-treetable-toggler + .p-checkbox + span, .changeHandling-wrapper .p-treetable .p-treetable-toggler + .p-checkbox + span {
  text-overflow: ellipsis;
  width: 80%;
  overflow: nowrap;
  overflow: hidden;
}
.rework-wrapper .p-treetable .p-treetable-tbody > tr.p-highlight, .changeHandling-wrapper .p-treetable .p-treetable-tbody > tr.p-highlight {
  background: none;
  color: inherit;
}
.rework-wrapper .headerWrapper, .changeHandling-wrapper .headerWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}
.rework-wrapper .headerWrapper .pi-angle-down, .changeHandling-wrapper .headerWrapper .pi-angle-down {
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms ease all;
  color: #003da5;
  font-size: 2rem;
  transition: 0.5s;
}
.rework-wrapper .headerWrapper .pi-angle-down:not(.collapsed), .changeHandling-wrapper .headerWrapper .pi-angle-down:not(.collapsed) {
  transform: rotate(180deg);
}
.rework-wrapper .headerWrapper .pi-angle-down:is(.collapsed), .changeHandling-wrapper .headerWrapper .pi-angle-down:is(.collapsed) {
  transform: rotate(0deg);
}
.rework-wrapper .headerWrapper .pi-angle-right, .changeHandling-wrapper .headerWrapper .pi-angle-right {
  font-weight: normal;
  font-size: 0.875rem;
}
.rework-wrapper #reworkDialog_header, .changeHandling-wrapper #reworkDialog_header {
  width: 90%;
}
.rework-wrapper #reworkDialog, .changeHandling-wrapper #reworkDialog {
  width: 90vw;
}
.rework-wrapper #reworkDialog .p-dialog-content, .changeHandling-wrapper #reworkDialog .p-dialog-content {
  padding: 0;
  min-height: 12.5rem;
}
.rework-wrapper #reworkDialog .p-dialog-content header, .changeHandling-wrapper #reworkDialog .p-dialog-content header {
  color: #003da5;
  font-weight: bold;
  padding: 0.625rem 0rem;
  background: #edf4fa;
  padding-left: 1.063rem;
}
.rework-wrapper #reworkDialog .p-dialog-content .contentWrapper, .changeHandling-wrapper #reworkDialog .p-dialog-content .contentWrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}
.rework-wrapper #reworkDialog .p-dialog-content .markup, .changeHandling-wrapper #reworkDialog .p-dialog-content .markup {
  color: #003da5;
}
.rework-wrapper #reworkDialog .p-dialog-content .flex-item, .changeHandling-wrapper #reworkDialog .p-dialog-content .flex-item {
  position: relative;
  font-weight: bold;
}
.rework-wrapper #reworkDialog .p-dialog-content .flex-item select,
.rework-wrapper #reworkDialog .p-dialog-content .flex-item input,
.rework-wrapper #reworkDialog .p-dialog-content .flex-item .markup, .changeHandling-wrapper #reworkDialog .p-dialog-content .flex-item select,
.changeHandling-wrapper #reworkDialog .p-dialog-content .flex-item input,
.changeHandling-wrapper #reworkDialog .p-dialog-content .flex-item .markup {
  margin-top: 0.625rem;
  min-width: 12.375rem;
  max-width: 8.375rem;
}
.rework-wrapper #reworkDialog .p-dialog-content .flex-item:not(:first-child):after, .changeHandling-wrapper #reworkDialog .p-dialog-content .flex-item:not(:first-child):after {
  content: "";
  position: absolute;
  background: #acacac;
  width: 0.063rem;
  height: 100%;
  top: 0%;
  left: -0.938rem;
}
.rework-wrapper .infoImage, .changeHandling-wrapper .infoImage {
  margin: 0px 7px;
  cursor: pointer;
  position: 222px;
  left: 118px;
  top: 5px;
}
.rework-wrapper .actions-rework, .changeHandling-wrapper .actions-rework {
  padding-right: 2.625rem;
  display: flex;
  justify-content: space-between;
  padding: 0.938rem 2.625rem;
}
.rework-wrapper .action-button-rework, .changeHandling-wrapper .action-button-rework {
  display: flex;
  gap: 1.25rem;
  align-items: center;
}
.rework-wrapper .action-button-rework .expand-collapse, .changeHandling-wrapper .action-button-rework .expand-collapse {
  height: 19px;
  width: 24px;
  cursor: pointer;
}
.rework-wrapper .myProjectAnddAllProjectList, .changeHandling-wrapper .myProjectAnddAllProjectList {
  height: 100vh;
  overflow: scroll;
}
.rework-wrapper .myProjectAnddAllProjectList .rejectionReason, .changeHandling-wrapper .myProjectAnddAllProjectList .rejectionReason {
  width: "70vw";
}
.rework-wrapper .myProjectAnddAllProjectList .card, .changeHandling-wrapper .myProjectAnddAllProjectList .card {
  height: 100%;
}
.rework-wrapper .myProjectAnddAllProjectList .card .p-treetable, .changeHandling-wrapper .myProjectAnddAllProjectList .card .p-treetable {
  height: calc(100% - 165px);
}
.rework-wrapper .myProjectAnddAllProjectList .card .p-treetable-frozen-view .p-treetable-scrollable-body, .changeHandling-wrapper .myProjectAnddAllProjectList .card .p-treetable-frozen-view .p-treetable-scrollable-body {
  padding-bottom: 8px !important;
}
.rework-wrapper .myProjectAnddAllProjectList .checked-row, .changeHandling-wrapper .myProjectAnddAllProjectList .checked-row {
  color: unset;
}
.rework-wrapper .myProjectAnddAllProjectList .checked-row .p-inputtext, .changeHandling-wrapper .myProjectAnddAllProjectList .checked-row .p-inputtext {
  color: unset;
}
.rework-wrapper .myProjectAnddAllProjectList .disabled-checkbox .p-checkbox-box, .changeHandling-wrapper .myProjectAnddAllProjectList .disabled-checkbox .p-checkbox-box {
  margin-bottom: 3px;
  background-color: rgb(225, 225, 225);
}
.rework-wrapper .myProjectAnddAllProjectList .change-colour, .changeHandling-wrapper .myProjectAnddAllProjectList .change-colour {
  color: #002c7a;
}
.rework-wrapper .myProjectAnddAllProjectList .disabled, .changeHandling-wrapper .myProjectAnddAllProjectList .disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.rework-wrapper .myProjectAnddAllProjectList .SelectionPopUpOverlay, .changeHandling-wrapper .myProjectAnddAllProjectList .SelectionPopUpOverlay {
  width: 65vw;
}
@media (max-width: 960px) {
  .rework-wrapper .myProjectAnddAllProjectList .SelectionPopUpOverlay, .changeHandling-wrapper .myProjectAnddAllProjectList .SelectionPopUpOverlay {
    width: 75vw;
  }
}
@media (max-width: 641px) {
  .rework-wrapper .myProjectAnddAllProjectList .SelectionPopUpOverlay, .changeHandling-wrapper .myProjectAnddAllProjectList .SelectionPopUpOverlay {
    width: 100vw;
  }
}
.rework-wrapper #pr_id_2_content, .changeHandling-wrapper #pr_id_2_content {
  width: 100%;
}
.rework-wrapper footer, .changeHandling-wrapper footer {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  position: fixed;
  right: 2.5rem;
  bottom: 1.25rem;
}
.rework-wrapper button, .changeHandling-wrapper button {
  cursor: pointer;
}
.rework-wrapper .p-breadcrumb .p-breadcrumb-list, .changeHandling-wrapper .p-breadcrumb .p-breadcrumb-list {
  padding-left: 0px;
}
.rework-wrapper .p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator, .changeHandling-wrapper .p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {
  margin: 0 0.5rem 0 0.5rem;
  color: grey;
}
.rework-wrapper .p-breadcrumb .p-breadcrumb-list li:nth-child(1), .changeHandling-wrapper .p-breadcrumb .p-breadcrumb-list li:nth-child(1) {
  display: block;
}
.rework-wrapper .p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text, .changeHandling-wrapper .p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {
  color: #003da5;
  font-weight: 600;
}
.rework-wrapper .p-breadcrumb .p-breadcrumb-list .lastElement, .changeHandling-wrapper .p-breadcrumb .p-breadcrumb-list .lastElement {
  color: #003da5;
  font-size: 14px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/containers/Rework/index.scss"],"names":[],"mappings":"AAIE;EACE,YAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAQE;EACE,WAAA;AANJ;;AAWE;EACE,WAAA;AARJ;AAWE;EACE,YAAA;AATJ;AAaI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAXN;AAgBQ;;;EAEE,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAbV;AAkBY;EACE,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAhBd;AAuBI;EACI,gBAAA;EACA,cAAA;AArBR;AAyBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAvBJ;AAyBI;EACE,eAAA;EACA,yBAAA;EAIA,0BAAA;EACA,cA/EI;EAgFJ,eAAA;EACA,gBAAA;AAvBN;AAyBM;EACE,yBAAA;AAvBR;AA0BM;EACE,uBAAA;AAxBR;AA4BI;EACE,mBAAA;EACA,mBAAA;AA1BN;AA8BE;EACE,UAAA;AA5BJ;AA+BE;EACE,WAAA;AA7BJ;AA+BI;EACE,UAAA;EACA,mBAAA;AA7BN;AA+BM;EACE,cA9GE;EA+GF,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AA7BR;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AA9BR;AAiCM;EACE,cA/HE;AAgGV;AAkCM;EACE,kBAAA;EACA,iBAAA;AAhCR;AAkCQ;;;;;EAGE,oBAAA;EACA,oBAAA;EACA,mBAAA;AA9BV;AAkCM;EACE,WAAA;EACA,kBAAA;EACA,mBAjJI;EAkJJ,eAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;AAhCR;AAsCE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EAEA,WAAA;EACA,QAAA;AArCJ;AAwCE;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,0BAAA;AAtCJ;AAyCE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAvCJ;AAyCI;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAvCN;AA2CE;EACE,aAAA;EACA,gBAAA;AAzCJ;AA2CI;EACE,aAAA;AAzCN;AA4CI;EACE,YAAA;AA1CN;AA4CM;EACE,0BAAA;AA1CR;AA8CQ;EACE,8BAAA;AA5CV;AAiDI;EACE,YAAA;AA/CN;AAiDM;EACE,YAAA;AA/CR;AAmDI;EACE,kBAAA;EACA,oCAAA;AAjDN;AAoDI;EACE,cAAA;AAlDN;AAqDI;EACE,YAAA;EACA,mBAAA;AAnDN;AAsDI;EACE,WAAA;AApDN;AAuDI;EACE;IACE,WAAA;EArDN;AACF;AAwDI;EACE;IACE,YAAA;EAtDN;AACF;AA0DE;EACE,WAAA;AAxDJ;AA2DE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAzDJ;AA4DE;EACE,eAAA;AA1DJ;AA8DI;EACE,iBAAA;AA5DN;AA8DM;EACE,yBAAA;EACA,WAAA;AA5DR;AA+DM;EACE,cAAA;AA7DR;AAiEQ;EACE,cArRA;EAsRA,gBAAA;AA/DV;AAmEM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjER","sourcesContent":["$primary: #003da5;\n$secondary: #acacac;\n\n.reworkTable {\n  .task-field-width {\n    width: 400px;\n  }\n\n  .non-task-width {\n    width: 110px;\n  }\n\n  .role-field-width {\n    width: 120px;\n  }\n\n  .customized-min-width {\n    width: 80px;\n  }\n}\n\n.rework-wrapper,.changeHandling-wrapper {\n  .dropdown-width {\n    width: 100%;\n  }\n\n  .p-column-header-content {\n    padding: 5px;\n  }\n\n  .p-treetable {\n    .fontBoldcolor {\n      font-weight: bold;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    .p-treetable-toggler {\n      + {\n        span,\n        a {\n          text-overflow: ellipsis;\n          width: 88%;\n          overflow: nowrap;\n          overflow: hidden;\n        }\n\n        .p-checkbox {\n          + {\n            span {\n              text-overflow: ellipsis;\n              width: 80%;\n              overflow: nowrap;\n              overflow: hidden;\n            }\n          }\n        }\n      }\n    }\n\n    .p-treetable-tbody > tr.p-highlight {\n        background: none;\n        color: inherit;\n      }\n  }\n\n  .headerWrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n\n    .pi-angle-down {\n      cursor: pointer;\n      transform: rotate(180deg);\n      -webkit-transition: 300ms ease all;\n      -moz-transition: 300ms ease all;\n      -o-transition: 300ms ease all;\n      transition: 300ms ease all;\n      color: $primary;\n      font-size: 2rem;\n      transition: 0.5s;\n\n      &:not(.collapsed) {\n        transform: rotate(180deg);\n      }\n\n      &:is(.collapsed) {\n        transform: rotate(0deg);\n      }\n    }\n\n    .pi-angle-right {\n      font-weight: normal;\n      font-size: 0.875rem;\n    }\n  }\n\n  #reworkDialog_header {\n    width: 90%;\n  }\n\n  #reworkDialog {\n    width: 90vw;\n\n    .p-dialog-content {\n      padding: 0;\n      min-height: 12.5rem;\n\n      header {\n        color: $primary;\n        font-weight: bold;\n        padding: 0.625rem 0rem;\n        background: #edf4fa;\n        padding-left: 1.063rem;\n      }\n\n      .contentWrapper {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        list-style: none;\n        padding: 0;\n        margin-bottom: 2rem;\n      }\n\n      .markup {\n        color: $primary;\n      }\n\n      .flex-item {\n        position: relative;\n        font-weight: bold;\n\n        select,\n        input,\n        .markup {\n          margin-top: 0.625rem;\n          min-width: 12.375rem;\n          max-width: 8.375rem;\n        }\n      }\n\n      .flex-item:not(:first-child):after {\n        content: \"\";\n        position: absolute;\n        background: $secondary;\n        width: 0.063rem;\n        height: 100%;\n        top: 0%;\n        left: -0.938rem;\n        // transform: translateY(-50%);\n      }\n    }\n  }\n\n  .infoImage {\n    margin: 0px 7px;\n    cursor: pointer;\n    position: 222px;\n\n    left: 118px;\n    top: 5px;\n  }\n\n  .actions-rework {\n    padding-right: 2.625rem;\n    display: flex;\n    justify-content: space-between;\n    padding: 0.938rem 2.625rem;\n  }\n\n  .action-button-rework {\n    display: flex;\n    gap: 1.25rem;\n    align-items: center;\n\n    .expand-collapse {\n      height: 19px;\n      width: 24px;\n      cursor: pointer;\n    }\n  }\n\n  .myProjectAnddAllProjectList {\n    height: 100vh;\n    overflow: scroll;\n\n    .rejectionReason {\n      width: \"70vw\";\n    }\n\n    .card {\n      height: 100%;\n\n      .p-treetable {\n        height: calc(100% - 165px);\n      }\n\n      .p-treetable-frozen-view {\n        .p-treetable-scrollable-body {\n          padding-bottom: 8px !important;\n        }\n      }\n    }\n\n    .checked-row {\n      color: unset;\n\n      .p-inputtext {\n        color: unset;\n      }\n    }\n\n    .disabled-checkbox .p-checkbox-box {\n      margin-bottom: 3px;\n      background-color: rgb(225, 225, 225);\n    }\n\n    .change-colour {\n      color: #002c7a;\n    }\n\n    .disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    .SelectionPopUpOverlay {\n      width: 65vw;\n    }\n\n    @media (max-width: 960px) {\n      .SelectionPopUpOverlay {\n        width: 75vw;\n      }\n    }\n\n    @media (max-width: 641px) {\n      .SelectionPopUpOverlay {\n        width: 100vw;\n      }\n    }\n  }\n\n  #pr_id_2_content {\n    width: 100%;\n  }\n\n  footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 2rem;\n    position: fixed;\n    right: 2.5rem;\n    bottom: 1.25rem;\n  }\n\n  button {\n    cursor: pointer;\n  }\n\n  .p-breadcrumb {\n    .p-breadcrumb-list {\n      padding-left: 0px;\n\n      li.p-menuitem-separator {\n        margin: 0 0.5rem 0 0.5rem;\n        color: grey;\n      }\n\n      li:nth-child(1) {\n        display: block;\n      }\n\n      li:last-child {\n        .p-menuitem-text {\n          color: $primary;\n          font-weight: 600;\n        }\n      }\n\n      .lastElement {\n        color: #003da5;\n        font-size: 14px;\n        font-weight: 600;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
